//acceso a un evento con fallback por si algun dato falla o falta
import moment from "moment-timezone";

export const SIN_DATO = "—";

/* Las fechas de los eventos se muestran siempre en hora de Argentina, igual que
 * se cargan en el formulario (domain/evento/payload.js): con la hora del
 * navegador, alguien en otro huso veía otro día u otra hora. */
const ZONA = "America/Argentina/Buenos_Aires";

/* --- fechas --- */

export const primeraFecha = (evento) => evento?.fechas?.[0] ?? null;

export const ultimaFecha = (evento) => {
  const fechas = evento?.fechas;
  return fechas?.length ? fechas[fechas.length - 1] : null;
};

export const tieneFechas = (evento) => Boolean(evento?.fechas?.length);

/* formateo de la primer fecha del evento con fallback para eventos sin fecha */
const formatearCampoFecha = (evento, campo, formato, fallback) => {
  const fecha = primeraFecha(evento);
  const valor = fecha?.[campo];
  if (!valor) return fallback;

  const m = moment(valor).tz(ZONA);
  return m.isValid() ? m.format(formato) : fallback;
};

export const fechaEventoTexto = (evento, formato = "DD/MM/YYYY", fallback = SIN_DATO) =>
  formatearCampoFecha(evento, "fecha", formato, fallback);

export const horaInicioTexto = (evento, formato = "LT", fallback = SIN_DATO) =>
  formatearCampoFecha(evento, "hora_inicio", formato, fallback);

export const horaFinTexto = (evento, formato = "LT", fallback = SIN_DATO) =>
  formatearCampoFecha(evento, "hora_fin", formato, fallback);

/* "12/04" para un evento de un día, "12/04 – 15/04" para uno de varios. */
export const rangoFechasTexto = (evento, formato = "DD/MM/YYYY", fallback = SIN_DATO) => {
  const inicio = fechaEventoTexto(evento, formato, null);
  if (!inicio) return fallback;

  const fin = ultimaFecha(evento)?.fecha;
  const finTexto = fin ? moment(fin).tz(ZONA).format(formato) : null;

  return finTexto && finTexto !== inicio ? `${inicio} – ${finTexto}` : inicio;
};

/* --- imágenes --- */

/* avatar y banner se identifican por sus flags, no por su posición en el array. */
export const avatarUrl = (evento, fallback = null) =>
  evento?.attachs?.find((attach) => attach.avatar)?.url ?? fallback;

export const bannerUrl = (evento, fallback = null) =>
  evento?.attachs?.find((attach) => attach.banner)?.url ?? fallback;

export const primerAttach = (evento) => evento?.attachs?.[0] ?? null;
